import React, { useState, useEffect } from "react";
import { useLocation } from 'react-router-dom';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import axios from "axios";
import { apiUrl } from "src/config/api";
import { FILE_URL } from "src/constants";
import { Modal, Fade, Backdrop } from "@material-ui/core";
// const baseUrl = "https://gritdev.s3.us-east-2.amazonaws.com/";
const useStyles = makeStyles((theme) => ({
  customDialog: {
    backgroundColor: "#ffffff",
    padding: theme.spacing(2),
    maxWidth: "700px",
  },
}));
const ViewModal = (props: any) => {
  const { modalContent, open, handleClose, isDirector } = props;
  const [data, setData] = useState<any>(null);
  const [NoteList, setNoteList] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [noteModalVisible, setNoteModalVisible] = useState(false);
  const classes = useStyles();
  const location = useLocation();

  useEffect(() => {
    const getViewDetailData = async () => {
      if (open && modalContent && modalContent.id) {
        setLoading(true);
        try {
          const url = props.selectedTab === 0 ? "getListOneCheque" : "getOneSubscrition"
          const response = await axios.get(
            apiUrl(`/payment/${url}/${modalContent.id}`)
          );
          // if (response.data?.length > 0) {
          // setData(response?.data?.data[0]);
          console.log(response?.data
            , "response............view")
          // } else {
          if (response?.data?.status) {
            setData(response?.data);
          }
          // setData(null);
          // }
        } catch (error) {
          console.error("Error fetching data", error);
        } finally {
          setLoading(false);
        }
      }
    };

    getViewDetailData();
  }, [open, modalContent?.id, props.selectedTab]);

  const CloseButton = () => {
    return (
      <button
        onClick={handleClose}
        style={{ border: "none", background: "none" }}
      >
        <CloseIcon />
      </button>
    );
  };
  function CFS(text: any = "") {
    console.log(text, "text...........")
    const safeText = text === null || text === undefined ? "" : String(text);
    return safeText
      ?.split(/([.!?]\s+)/) // Split by sentence-ending punctuation followed by space.
      ?.map((sentence: any) => sentence?.charAt(0)?.toUpperCase() + sentence?.slice(1))
      ?.join('');
  }

  const changeChequeName = (value: string) => {
    if (value === 'Cheque') {
      return 'Check'
    }
    return value
  }

  function planFrequently(key: any) {
    switch (key) {
      case 'yearly':
        return 'yr'

      default:
        return key
    }
  }

  function getDisplayPaymentAmount(baseAmount: any, paymentMethodRaw: any) {
    const paymentMethod = String(paymentMethodRaw || "").toLowerCase();
    const amount = Number(baseAmount ?? 0);

    if (paymentMethod === "free") {
      return 0;
    }

    if (paymentMethod === "stripe") {
      return amount * 1.03;
    }

    return amount;
  }

  function CheckDetailsRender() {
    const paymentMethod = data?.data?.payment?.payment_method;
    const basePaymentAmount = Number(data?.data?.payment?.payment_amount ?? 0);
    const paymentAmount = getDisplayPaymentAmount(basePaymentAmount, paymentMethod);

    return (
      <div style={{ position: "relative" }}>
        <p>
          <strong>Name:</strong> {CFS(data?.data?.user?.firstName)} {CFS(data?.data?.user?.lastName)}
        </p>
        <p>
          <strong>Email:</strong> {data?.data?.user?.email}
        </p>
        <p>
          <strong>Status:</strong> {CFS(data?.data?.status)}
        </p>
        <p>
          <strong>School Organization:</strong> {CFS(data?.data?.school?.name)}
        </p>
        <p>
          <strong>Payment Method:</strong> {changeChequeName(CFS(data?.data?.payment?.payment_method))}
        </p>
        <p>
          <strong>Payment Amount:</strong> ${paymentAmount.toFixed(2)}
        </p>
        <p>
          <strong>Payment Status:</strong> {CFS(data?.data?.payment?.status)}
        </p>
        <p>
          <strong>Agreement</strong>
          <a href={FILE_URL + "/" + data?.data?.payment?.agreement} target="_blank" rel="noopener noreferrer">
            &nbsp; {"View"}
          </a>
        </p>
        <p>
          <strong>Payment Invoice</strong>
          {(() => {
            try {
              const resultData = JSON.parse(data?.data?.payment?.result_data);
              return (
                <a href={FILE_URL + "/" + resultData?.invoice} target="_blank" rel="noopener noreferrer">
                  &nbsp; {"View"}
                </a>
              );
            } catch (error) {
              // console.error("Failed to parse JSON or construct URL", error);
              return null;
            }
          })()}
        </p>
        {/* Plan Table */}        
        <div style={{ marginBottom: 10 }}>
          <strong>Plan:</strong>      
          {data?.data?.plan ? (
            <TableContainer component={Paper} style={{ marginTop: 16 }}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>
                      <strong>Title</strong>
                    </TableCell>
                    <TableCell>
                      <strong>Description</strong>
                    </TableCell>
                    <TableCell>
                      <strong>Price</strong>
                    </TableCell>
                    <TableCell>
                      <strong>Teachers</strong>
                    </TableCell>
                    <TableCell>
                      <strong>Status</strong>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell>{CFS(data?.data?.plan?.title)}</TableCell>
                    <TableCell>{CFS(data?.data?.plan?.description)}</TableCell>
                    <TableCell>${data?.data?.plan?.price}/{planFrequently(data?.data?.plan?.payment_frequency_type)}</TableCell>
                    <TableCell>{data?.data?.plan?.coachs || "N/A"}</TableCell>
                    <TableCell>{CFS(data?.data?.plan?.status)}</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <p>No Plan Available</p>
          )}
        </div>

        {/* Addons Table */}
        <div>
          <strong>Addons:</strong>
          {data?.data?.payment?.addons?.length > 0 ? (
            <TableContainer component={Paper} style={{ marginTop: 16 }}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>
                      <strong>Title</strong>
                    </TableCell>
                    <TableCell>
                      <strong>Description</strong>
                    </TableCell>
                    <TableCell>
                      <strong>Price</strong>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {data?.data?.payment?.addons?.map((addon: any, index: number) => (
                    <TableRow key={index}>
                      <TableCell>{CFS(addon?.title)}</TableCell>
                      <TableCell>{CFS(addon?.description)}</TableCell>
                      <TableCell>${addon?.price}/{planFrequently(addon?.payment_frequency_type)}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <p>No Addons Available</p>
          )}
        </div>
      </div>
    )
  }
  function MemberShipDetailsRender() {


    const handleOpenNoteModal = (noteList: any) => {
      const noteData = noteList;
      if (noteData) {
        const list = JSON.parse(noteData);
        setNoteList(list)
      } else {
        console.error("Note data is undefined or invalid");
      }
      setNoteModalVisible(true);
    };

    const handleCloseNoteModal = () => {
      setNoteModalVisible(false);
    };
    return (
      <div style={{ position: "relative" }}>
        {location.pathname === "/admin/inquire" && ( <p>
          <strong>Note:</strong>
          {/* {data?.membership?.note} */}
          <button onClick={() => { handleOpenNoteModal(data?.membership?.note) }} className="view-page-inner" >
            View
          </button>
        </p>
        )
      }
        <p>
          <strong>Name:</strong> {CFS(data?.data?.user?.firstName)} {CFS(data?.data?.user?.lastName)}
        </p>
        <p>
          <strong>Email:</strong> {data?.data?.user?.email}
        </p>
        <p>
          <strong>Status:</strong> {CFS(data?.data?.membership?.status)}
        </p>
        <p>
          <strong>School Organization:</strong> {CFS(data?.data?.school?.name)}
        </p>
        <p>
          <strong>Subscription Type:</strong> {changeChequeName(CFS(data?.data?.membership?.subscription_type))}
        </p>
        {data?.membership?.subscription_type === "stripe" && <p>
          <strong>Subscription ID:</strong> {CFS(data?.data?.membership?.subscription_no)}
        </p>}
        <div>
          {
            data?.data?.paymentHistory?.length > 0 ?
              data?.data?.paymentHistory.map((item: any) => {
                console.log(item, "item.............")
                const paymentMethod = String(item?.payment?.payment_method || "").toLowerCase();
                const planAmount = Number(item?.plan?.price ?? 0);
                const basePaymentAmount = Number(item?.price ?? item?.payment?.payment_amount ?? 0);
                const paymentAmount = getDisplayPaymentAmount(basePaymentAmount, paymentMethod);

                return (
                  <div key={item?.id} style={{ borderWidth: 1 }}>
                    <p>
                      <strong>Payment Method:</strong> {changeChequeName(CFS(item.payment?.payment_method))}
                    </p>
                    <p> <strong>Plan Amount: </strong>
                      ${planAmount.toFixed(2)}
                    </p>
                   
                    <p>
                      <strong>Payment Amount:</strong>
                      ${paymentAmount.toFixed(2)}
                    </p>

                    <p>
                      <strong>Payment Status:</strong> {CFS(item.payment?.status)}
                    </p>

                    <p>
                      <strong>Agreement</strong>
                      <a href={FILE_URL + "/" + item?.payment?.agreement} target="_blank" rel="noopener noreferrer">
                        &nbsp; {"View"}
                      </a>
                    </p>
                    <p>
                      <strong>Payment Invoice</strong>
                      {(isDirector === true && item?.payment?.checkstatus === false) ? ': Pending' : (() => {
                        try {
                          const resultData = JSON.parse(item?.payment?.result_data);
                          return (
                            <a href={FILE_URL + "/" + resultData?.invoice} target="_blank" rel="noopener noreferrer">
                              &nbsp; {"View"}
                            </a>
                          );
                        } catch (error) {
                          // console.error("Failed to parse JSON or construct URL", error);
                          return null;
                        }
                      })()}
                    </p>
                    {/* Plan Table */}
                    <div style={{ marginBottom: 10 }}>
                      <strong>Plan:</strong>
                      {item?.plan ? (
                        <TableContainer component={Paper} style={{ marginTop: 16 }}>
                          <Table>
                            <TableHead>
                              <TableRow>
                                <TableCell>
                                  <strong>Title</strong>
                                </TableCell>
                                <TableCell>
                                  <strong>Description</strong>
                                </TableCell>
                                <TableCell>
                                  <strong>Price</strong>
                                </TableCell>
                                <TableCell>
                                  <strong>Teachers</strong>
                                </TableCell>
                                <TableCell>
                                  <strong>Status</strong>
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              <TableRow>
                                <TableCell>{CFS(item?.plan?.title)}</TableCell>
                                <TableCell>{CFS(item?.plan?.description || "N/A")}</TableCell>
                                <TableCell>${Number(item?.plan?.price ?? 0).toFixed(2)}/{planFrequently(item?.plan?.payment_frequency_type)}</TableCell>
                                <TableCell>{item?.plan?.coachs || "N/A"}</TableCell>
                                <TableCell>{CFS(item?.plan?.status)}</TableCell>
                              </TableRow>
                            </TableBody>
                          </Table>
                        </TableContainer>
                      ) : (
                        <p>No Plan Available</p>
                      )}
                    </div>
                  </div>
                )
              })
              : null
          }
        </div>

        <Modal
          open={noteModalVisible}
          onClose={handleCloseNoteModal}
          closeAfterTransition={true}
          BackdropComponent={Backdrop}
          BackdropProps={{ timeout: 500 }}
        >
          <Fade in={noteModalVisible}>
            <div
              style={{
                backgroundColor: "white",
                padding: "20px",
                borderRadius: "10px",
                maxWidth: "650px",
                margin: "auto",
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: "80%",
              }}
            >
              <div className="note-inner-mod">
                <h2>Note</h2>
                <span
                style={{cursor:"pointer"}}
                  onClick={handleCloseNoteModal}
                >
                  <CloseIcon />
                </span>
              </div>
              <div className="note-inner-list">
              {NoteList?.map((row: any, index: number) => {
                return (
                  <>

                 <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tr className="membership-over">
                      {row?.date_note !== null &&
                       <td style={{ border: "1px solid #ddd", padding: "8px",width:"20%" }}>
                        {row?.date_note} </td>}
                      <td style={{ border: "1px solid #ddd", padding: "8px" }}><p className="s">{row?.note !== "" ? row?.note : ""}</p></td></tr>
                    </table>
                  </>
                )

              })}
</div>

            </div>
          </Fade>
        </Modal>

        {/* Addons Table removed as per request */}
      </div>
    )
  }
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="md"
      fullWidth={true}
      classes={{ paper: classes.customDialog }}
    >
      <DialogTitle>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div>View Details</div> <div>{CloseButton()}</div>
        </div>
      </DialogTitle>

      <DialogContent>
        {loading ? (
          <p>Loading...</p>
        ) : data ? props.selectedTab === 0 ? CheckDetailsRender() : MemberShipDetailsRender() : (
          <p>No content available</p>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ViewModal;



// WEBPACK FOOTER //
// ./src/components/ViewModal/index.tsx